import classNames from 'classnames';
import styled from 'styled-components';
import { domProps } from 'shared/utils/form';
import { AddlFieldType } from 'shared/constants/fields';

const StyledLabel = styled.label`
  color: ${(p) => p.theme.color.palette.text.main};
`;

export default function Label({
  fieldType = '',
  required = false,
  readOnly = false,
  children,
  ...props
}) {
  if (fieldType === AddlFieldType.BOOL) return null;
  return (
    <StyledLabel
      className={classNames(
        'fs-8 fw-medium lh-1 ls-1 text-uppercase',
        readOnly && 'text-muted cursor-not-allowed'
      )}
      aria-disabled={readOnly}
      {...domProps(props)}
    >
      {children}
      {required && <span className="text-danger">&nbsp;*</span>}
    </StyledLabel>
  );
}
